import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { TicketStore, TicketState } from './ticket.store';
import { map, Observable } from 'rxjs';
import { Ticket } from './models/ticket.model';
import { TicketFlag } from '../models/ticket.enums';

@Injectable({ providedIn: 'root' })
export class TicketQuery extends QueryEntity<TicketState> {
  constructor(protected store: TicketStore) {
    super(store);
  }

  selectAllTickets(): Observable<Ticket[]> {
    return this.selectAll();
  }

  getTicketInformation(gameNumber: number) {
    let ticketInfo = {
      TicketsAvailableToTransfer: this.getCount(
        (ticket) =>
          ticket.GameNumber === gameNumber && ticket.Flag === TicketFlag.ACTIVE
      ),
      TicketsTransferred: this.getCount(
        (ticket) =>
          ticket.GameNumber === gameNumber &&
          TicketFlag.TRANSFERRED === this.checkFlag(ticket.Flag, TicketFlag.TRANSFERRED)
      ),
      WindowEndDate: this.getAll({
        filterBy: (ticket) => ticket.GameNumber === gameNumber && ticket.IsCallbackAllowed && ticket.IsTransferToEmailAllowed,
      }).map((ticket) => {
        return ticket.EndTime;
      })[0],
      WindowStartDate: this.getAll({
        filterBy: (ticket) => ticket.GameNumber === gameNumber && ticket.IsCallbackAllowed && ticket.IsTransferToEmailAllowed,
      }).map((ticket) => {
        return ticket.StartTime;
      })[0],
    };

    return ticketInfo;
  }

  selectTicketsForGame(gameNumber: number) {
    return this.selectAll({
      filterBy: (ticket) => ticket.GameNumber === gameNumber,
    });
  }

  selectDefaultTicket(gameNumber: number): Observable<Ticket | undefined> {
    return this.selectTicketsForGame(gameNumber).pipe(
      map((tickets) => tickets[0])
    );
  }

  selectedTickets() {
    return this.selectAll({ filterBy: (ticket) => ticket.selected });
  }

  selectTransferredTickets() {
    return this.selectAll({ filterBy: (ticket) => ticket.Transferred });
  }

  selectTransferredTicketsForGame(gameNumber: Number) {
    return this.selectAll({
      filterBy: (ticket) =>
        ticket.GameNumber === gameNumber && TicketFlag.TRANSFERRED === this.checkFlag(ticket.Flag, TicketFlag.TRANSFERRED),
    });
  }

  selectAvaialbleTicketsForGame(gameNumber: Number) {
    return this.selectAll({ filterBy: (ticket) => ticket.GameNumber === gameNumber && ticket.Flag === TicketFlag.ACTIVE });
  }

  private checkFlag(status: number, flag: number) {
    // tslint:disable-next-line: no-bitwise
    return status & flag;
  }
}
